import { render, staticRenderFns } from "./product.vue?vue&type=template&id=4ff9a79a"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ff9a79a')) {
      api.createRecord('4ff9a79a', component.options)
    } else {
      api.reload('4ff9a79a', component.options)
    }
    module.hot.accept("./product.vue?vue&type=template&id=4ff9a79a", function () {
      api.rerender('4ff9a79a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/help/views/product.vue"
export default component.exports